import moment from "moment-timezone";
import numeral from "numeral";
import url from "@/services/Url";
import _ from "lodash";
import axios from "axios";
import platform from "platform";
import config from "@/configApp";
import { Capacitor } from "@capacitor/core";
import { parse } from "mathjs";

export const func = {
  getUrl() {
    return url;
  },
  getWL() {
    return localStorage.getItem("url") || "gwaysistemas";
  },
  getConfigWL() {
    const configWL = JSON.parse(sessionStorage.getItem("configWL"));
    return configWL === null || configWL === undefined ? undefined : configWL;
  },
  getNomeEmpresaWL() {
    const configWL = this.getConfigWL();
    return configWL && configWL.nome_empresa ? configWL.nome_empresa : "";
  },
  getSiteWL() {
    const configWL = this.getConfigWL();
    return configWL && configWL.site ? configWL.site : "";
  },
  getFrontendDocumentUrl(relativePath = "") {
    if (typeof window === "undefined") {
      return relativePath;
    }

    const basePath = process.env.BASE_URL || "/";
    const normalizedBasePath = basePath.endsWith("/")
      ? basePath
      : `${basePath}/`;
    const normalizedRelativePath = String(relativePath || "").replace(
      /^\/+/,
      ""
    );

    return `${window.location.origin}${normalizedBasePath}${normalizedRelativePath}`;
  },
  getLogoWL() {
    const configWL = this.getConfigWL();
    return configWL && configWL.logo
      ? this.getUrl() + configWL.logo
      : process.env.BASE_URL + "media/logos/gateway_logo.svg";
  },
  getLogoWhiteWL() {
    const configWL = this.getConfigWL();
    return configWL && configWL.logo_white
      ? this.getUrl() + configWL.logo_white
      : process.env.BASE_URL + "media/logos/gateway_white.svg";
  },
  getLogoBlackWL() {
    const configWL = this.getConfigWL();
    return configWL && configWL.logo_black
      ? this.getUrl() + configWL.logo_black
      : process.env.BASE_URL + "media/logos/gateway_black.svg";
  },
  getLoginFundoWL() {
    const configWL = this.getConfigWL();
    return configWL && configWL.login_fundo
      ? this.getUrl() + configWL.login_fundo
      : process.env.BASE_URL + "media/misc/bg-login.png";
  },
  getIconeWL() {
    const configWL = this.getConfigWL();
    return configWL && configWL.icone
      ? this.getUrl() + configWL.icone
      : process.env.BASE_URL + "favicon.ico";
  },
  getLoginTituloWL() {
    const configWL = this.getConfigWL();
    return configWL && configWL.login_titulo
      ? configWL.login_titulo
      : "Rápido, Eficiente e Produtivo";
  },
  getLoginDescricaoWL() {
    const configWL = this.getConfigWL();
    return configWL && configWL.login_descricao
      ? configWL.login_descricao.replace(
          new RegExp("/uploads/ConfiguracaoWhiteLabel", "g"),
          this.getUrl() + "/uploads/ConfiguracaoWhiteLabel"
        )
      : 'As soluções da <a href="http://sistemagestaoempresarial.com.br" class="opacity-75-hover text-warning fw-bold me-1">Gestão Empresarial</a> foram desenvolvidas para maximizar os processos <br/>gerenciais dentro de uma organização.';
  },
  updateIcone(newIcone) {
    let links = document.querySelectorAll("link[rel*='icon']");
    if (links.length === 0) {
      const link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
      links = document.querySelectorAll("link[rel*='icon']");
    }
    links.forEach((link) => {
      link.href = newIcone;
    });
  },
  updateSplash(newLogo) {
    const splashImg = document.querySelector("#splash-screen img");
    if (splashImg) {
      splashImg.src = newLogo;
    }
  },
  updateNomeEmpresa(newNomeEmpresa) {
    const nomeEmpresa = document.querySelector("title");
    if (nomeEmpresa) {
      nomeEmpresa.innerHTML = newNomeEmpresa;
    }
  },
  atualizarWL() {
    this.updateNomeEmpresa(this.getNomeEmpresaWL());
    this.updateIcone(this.getIconeWL());
    this.updateSplash(this.getLogoWL());
  },
  getTimeZoneServidor() {
    return "-03:00";
  },
  booleanToString: (obj) => {
    return obj === true ? "1" : "0";
  },
  stringToBoolean: (obj) => {
    return obj === "1" ? true : false;
  },
  checkToString: (obj) => {
    return obj.toString() === "checked" ? "1" : "0";
  },
  stringToChecked: (obj) => {
    return obj === "1" ? "checked" : "uncheck";
  },
  generateUuidv4: () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  },
  isNumber: (n) => {
    return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
  },
  isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
  },
  isInteger(value) {
    if (value === null || value === undefined) {
      return false;
    }

    if (typeof value === "string" && value.trim() === "") {
      return false;
    }

    // Converte o valor para um número usando o operador unário +
    const numericValue = +value;

    // Verifica se o valor convertido é um número válido
    if (isNaN(numericValue)) {
      return false;
    }

    // Verifica se o valor convertido é um número inteiro
    return Number.isInteger(numericValue);
  },
  isEquivalent(a, b) {
    // Create arrays of property names
    var aProps = a ? Object.getOwnPropertyNames(a) : "";
    var bProps = b ? Object.getOwnPropertyNames(b) : "";

    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length != bProps.length) {
      return false;
    }

    for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i];

      // If values of same property are not equal,
      // objects are not equivalent
      if (a[propName] !== b[propName]) {
        return false;
      }
    }

    // If we made it this far, objects
    // are considered equivalent
    return true;
  },
  // convertModelToFormData(model, form, namespace = "") {
  //   let formData = form || new FormData();

  //   for (let propertyName in model) {
  //     if (!model[propertyName] && !this.isNumber(model[propertyName])) continue;
  //     let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
  //     let formKeyFile = namespace
  //       ? `${namespace}.${propertyName}`
  //       : propertyName;
  //     if (model[propertyName] instanceof Date) {
  //       formData.append(
  //         formKey,
  //         moment(String(model[propertyName])).format("YYYY-MM-DD HH:mm:ss")
  //       );
  //     } else if (model[propertyName] instanceof Array) {
  //       model[propertyName].forEach((element, index) => {
  //         const tempFormKey = `${formKey}[${index}]`;
  //         this.convertModelToFormData(element, formData, tempFormKey);
  //       });
  //     } else if (
  //       typeof model[propertyName] === "object" &&
  //       !(model[propertyName] instanceof File)
  //     ) {
  //       this.convertModelToFormData(model[propertyName], formData, formKey);
  //     } else {
  //       if (model[propertyName] instanceof File) {
  //         formData.append(formKeyFile, model[propertyName]);
  //       } else {
  //         formData.append(formKey, model[propertyName].toString());
  //       }
  //     }
  //   }
  //   return formData;
  // },
  convertModelToFormData(model, form, namespace = "") {
    let formData = form || new FormData();

    for (let propertyName in model) {
      if (!model[propertyName] && !this.isNumber(model[propertyName])) continue;
      let formKey = namespace ? `${namespace}.${propertyName}` : propertyName;

      if (model[propertyName] instanceof Date) {
        formData.append(
          formKey,
          moment(String(model[propertyName])).format("YYYY-MM-DD HH:mm:ss")
        );
      } else if (model[propertyName] instanceof Array) {
        model[propertyName].forEach((element, index) => {
          const tempFormKey = `${formKey}[${index}]`;
          if (typeof element === "string") {
            formData.append(tempFormKey, element);
          } else {
            this.convertModelToFormData(element, formData, tempFormKey);
          }
        });
      } else if (
        typeof model[propertyName] === "object" &&
        !(model[propertyName] instanceof File)
      ) {
        this.convertModelToFormData(model[propertyName], formData, formKey);
      } else {
        formData.append(formKey, model[propertyName]);
      }
    }

    return formData;
  },
  getColors() {
    var colors = [
      "bg-light-primary text-primary",
      "bg-light-success text-success",
      "bg-light-info text-info",
      "bg-light-warning text-warning",
      "bg-light-danger text-danger",
      "bg-primary text-inverse-primary",
      "bg-success text-inverse-success",
      "bg-info text-inverse-info",
      "bg-warning text-inverse-warning",
      "bg-danger text-inverse-danger",
      "bg-dark text-inverse-dark",
    ];
    return colors;
  },
  getRandomIntInclusive: function (min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  },
  getColorRandom() {
    return this.getColors()[
      this.getRandomIntInclusive(0, this.getColors().length - 1)
    ];
  },
  formatarData(value) {
    if (value) {
      return moment(String(value)).format("DD/MM/YYYY");
    }
  },
  formatarDataSemFusoHorario(value) {
    if (value) {
      return moment.utc(value).format("DD/MM/YYYY");
    }
  },
  formatarDataHora(value) {
    if (value) {
      return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
    }
  },
  obterMomentoComFuso(value) {
    if (!value) {
      return null;
    }

    const texto = String(value);
    const possuiOffsetExplicito = /([zZ]|[+-]\d{2}:\d{2})$/.test(texto);

    if (possuiOffsetExplicito) {
      return moment.parseZone(texto);
    }

    return moment.utc(texto);
  },
  formatarDataHoraFusoHorario(value) {
    if (value) {
      const dataUTC = this.obterMomentoComFuso(value);
      const timeZone = moment.tz.guess();
      const dataLocal = dataUTC.tz(timeZone);

      return dataLocal.format("DD/MM/YYYY HH:mm:ss");
    }
  },
  formatarDataHoraCustomizadaFusoHorario(value) {
    if (value) {
      const dataUTC = this.obterMomentoComFuso(value);
      const timeZone = moment.tz.guess();
      const dataLocal = dataUTC.tz(timeZone);

      return dataLocal.format("DD MMM YYYY, HH:mm A");
    }
  },
  formatarDataHoraConsulta(value) {
    if (value) {
      return moment(String(value)).format("YYYY-MM-DDTHH:mm:ss");
    }
  },
  formatarDataHoraConsultaCustom(value, format) {
    if (value) {
      const dataUTC = this.obterMomentoComFuso(value);
      const timeZone = moment.tz.guess();
      const dataLocal = dataUTC.tz(timeZone);
      return dataLocal.format(format);
    }
  },
  formatarDataCustomizada(value) {
    if (value) {
      const data = moment(value);
      const dataAtual = moment();
      const diffDays = dataAtual.diff(data, "days");

      if (diffDays >= 30 && data.year() === dataAtual.year()) {
        return data.format("DD MMMM");
      } else if (diffDays > 1 && diffDays < 30) {
        return `${diffDays} dias atrás`;
      } else if (
        diffDays === 1 ||
        (diffDays === 0 && data.day() != dataAtual.day())
      ) {
        return "Ontem";
      } else if (diffDays === 0) {
        return data.format("HH:mm A");
      } else {
        return data.format("DD/MM/YYYY");
      }
    }
  },
  formatarDataCustomizadaFusoHorario(value) {
    if (value) {
      const dataUTC = this.obterMomentoComFuso(value);
      const timeZone = moment.tz.guess();
      const dataLocal = dataUTC.tz(timeZone);
      const dataAtualUTC = this.removerFusoHorario(new Date());
      const dataAtualLocal = moment.utc(dataAtualUTC).tz(timeZone);
      const diffDays = dataAtualLocal.diff(dataLocal, "days");

      if (diffDays >= 30 && dataLocal.year() === dataAtualLocal.year()) {
        return dataLocal.format("DD MMMM");
      } else if (diffDays > 1 && diffDays < 30) {
        return `${diffDays} dias atrás`;
      } else if (
        diffDays === 1 ||
        (diffDays === 0 && dataLocal.day() != dataAtualLocal.day())
      ) {
        return "Ontem";
      } else if (diffDays === 0) {
        return dataLocal.format("HH:mm A");
      } else {
        return dataLocal.format("DD/MM/YYYY");
      }
    }
  },
  removerFusoHorario(data) {
    if (data) {
      if (!(data instanceof Date)) {
        data = new Date(data);
      }
      const timeZoneOffset = data.getTimezoneOffset();

      return new Date(data.getTime() + timeZoneOffset * 60 * 1000);
    }
  },
  formatarHora(value) {
    if (value) {
      return moment(String(value)).format("HH:mm:ss");
    }
  },
  formatarHoraTimeSpan(value) {
    if (value && value.startsWith("PT")) {
      const duration = moment.duration(value);
      return moment.utc(duration.asMilliseconds()).format("HH:mm:ss");
    } else if (value) {
      // Caso o valor já esteja no formato "HH:mm:ss"
      return moment(value, "HH:mm:ss").format("HH:mm:ss");
    } else {
      return "";
    }
  },
  formatarHoraDuration(value) {
    if (!value) return null;

    const data = new Date(value);
    const horas = data.getHours();
    const minutos = data.getMinutes();
    const segundos = data.getSeconds();

    return `duration'PT${horas}H${minutos}M${segundos}S'`;
  },
  formatarNumero(numero) {
    let numeroFormatado = parseFloat(numero);
    if (isNaN(numeroFormatado)) {
      numeroFormatado = 0;
    }

    return numeral(numeroFormatado).format("0.00");
  },
  formatarNumeroCasas(numero, casasDecimais) {
    let formato = "0." + "0".repeat(casasDecimais);
    return numeral(numero).format(formato);
  },
  retornarValoresJson(object) {
    var values = [];
    var keys = Object.keys(object);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (
        !k.includes("Data") &&
        !k.includes("Message") &&
        !k.includes("Success")
      ) {
        values.push(object[k]);
      }
    }
    return values;
  },
  retornarValoresJsonAtalhoSimples(object) {
    var values = [];
    var keys = Object.keys(object);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (
        !k.includes("Data") &&
        !k.includes("Message") &&
        !k.includes("Success")
      ) {
        const error = object[k];
        const elemento = k;
        values.push({ error, elemento });
      }
    }
    return values;
  },
  retornarValoresJsonAtalho(object, mapper) {
    var values = [];
    var keys = Object.keys(object);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (
        !k.includes("Data") &&
        !k.includes("Message") &&
        !k.includes("Success")
      ) {
        const error = object[k];
        const elemento = k;
        const keyMapper = k.replace(/\[\d+\]/g, "");
        const tab = mapper[keyMapper] ? mapper[keyMapper][0] : "";
        const tabID = mapper[keyMapper] ? mapper[keyMapper][1] : "";
        const onClick = mapper[keyMapper] ? mapper[keyMapper][2] : "";
        const indices = this.retornarIndices(k);
        values.push({ error, elemento, tab, tabID, onClick, indices });
      }
    }
    return values;
  },
  retornarIndices(string) {
    const indices = [];
    const pattern = /\[(\d+)\]/g;
    let match;

    while ((match = pattern.exec(string)) !== null) {
      indices.push(parseInt(match[1]));
    }

    return indices;
  },
  setMask(value, mask, masked) {
    var tokens = {
      "#": {
        pattern: /\d/,
      },
      X: {
        pattern: /[0-9a-zA-Z]/,
      },
      S: {
        pattern: /[a-zA-Z]/,
      },
      A: {
        pattern: /[a-zA-Z]/,
        transform: (v) => v.toLocaleUpperCase(),
      },
      a: {
        pattern: /[a-zA-Z]/,
        transform: (v) => v.toLocaleLowerCase(),
      },
      "!": {
        escape: true,
      },
    };
    value = value || "";
    mask = mask || "";
    if (
      mask === "##.###.###/####-##" &&
      /^[0-9A-Z]{14}$/i.test(value) &&
      /[A-Z]/i.test(value)
    ) {
      mask = "XX.XXX.XXX/XXXX-XX";
    }
    var iMask = 0;
    var iValue = 0;
    var output = "";
    while (iMask < mask.length && iValue < value.length) {
      var cMask = mask[iMask];
      var masker = tokens[cMask];
      var cValue = value[iValue];
      if (masker && !masker.escape) {
        if (masker.pattern.test(cValue)) {
          output += masker.transform ? masker.transform(cValue) : cValue;
          iMask++;
        }
        iValue++;
      } else {
        if (masker && masker.escape) {
          iMask++; // take the next mask char and treat it as char
          cMask = mask[iMask];
        }
        if (masked) output += cMask;
        if (cValue === cMask) iValue++; // user typed the same char
        iMask++;
      }
    }

    // fix mask that ends with a char: (#)
    var restOutput = "";
    while (iMask < mask.length && masked) {
      var cMask2 = mask[iMask];
      if (tokens[cMask2]) {
        restOutput = "";
        break;
      }
      restOutput += cMask2;
      iMask++;
    }
    return output + restOutput;
  },
  unMask(value) {
    if (value !== null && value !== undefined && value !== "") {
      value = value.replace(/[^a-z0-9]/gi, "").toUpperCase();
    }
    return value;
  },
  normalizeCpfCnpj(value) {
    return this.unMask(value) || "";
  },
  isCpf(value) {
    return /^\d{11}$/.test(this.normalizeCpfCnpj(value));
  },
  isCnpj(value) {
    return /^[0-9A-Z]{14}$/.test(this.normalizeCpfCnpj(value));
  },
  isCnpjNumerico(value) {
    return /^\d{14}$/.test(this.normalizeCpfCnpj(value));
  },
  normalizeChaveAcesso(value) {
    return String(value || "")
      .replace(/[^0-9a-z]/gi, "")
      .toUpperCase();
  },
  formatCpfCnpj(value) {
    const documento = this.normalizeCpfCnpj(value);

    if (this.isCpf(documento)) {
      return this.setMask(documento, "###.###.###-##", true);
    }

    if (this.isCnpj(documento)) {
      return this.setMask(documento, "XX.XXX.XXX/XXXX-XX", true);
    }

    return value || "";
  },
  blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  },
  dataToBlob(data) {
    const base64String = data.FileContents;
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.ContentType });
    return blob;
  },
  base64ToBlob(data) {
    const base64String = data;
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.ContentType });
    return blob;
  },
  extractBase64Data(inputString) {
    const regex = /base64,(.*)/;
    const match = regex.exec(inputString);

    if (match && match.length > 1) {
      return match[1];
    } else {
      return null;
    }
  },
  checkEmail(email) {
    // eslint-disable-next-line
    //const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    // eslint-disable-next-line no-useless-escape
    const reg = /^\w+([\.-]?\w+)*(\+\w+)?@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (reg.test(email)) return false; //false - email válido
    return true; //true - email inválido
  },

  validarCST(cst) {
    if (cst !== undefined && cst !== null && cst !== "" && cst.length === 3) {
      var origem = cst.substring(0, 1);
      var operacao = cst.substring(1, 3);

      // Verificar a origem da mercadoria ou serviço
      switch (origem) {
        case "0":
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
          // Verificar a operação
          switch (operacao) {
            case "00":
            case "10":
            case "20":
            case "30":
            case "40":
            case "41":
            case "50":
            case "51":
            case "60":
            case "70":
            case "90":
            case "61":
              return true; // CST válido
            default:
              return false; // Operação inválida
          }
        default:
          return false; // Origem inválida
      }
    } else {
      return false; // CST inválido
    }
  },

  validarCSOSN(csosn) {
    if (
      csosn !== undefined &&
      csosn !== null &&
      csosn !== "" &&
      (csosn.length === 3 || csosn.length === 4)
    ) {
      var origem = csosn.substring(0, 1);
      var operacao =
        csosn.length === 4 ? csosn.substring(1, 4) : csosn.substring(1, 3);

      // Verificar a origem da mercadoria ou serviço
      switch (origem) {
        case "0":
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
          // Verificar a operação
          switch (operacao) {
            case "101":
            case "102":
            case "103":
            case "201":
            case "202":
            case "203":
            case "300":
            case "400":
            case "500":
            case "900":
            case "61":
              return true; // CSOSN válido
            default:
              return false; // Operação inválida
          }
        default:
          return false; // Origem inválida
      }
    } else {
      return false; // CSOSN inválido
    }
  },

  validarCPFCNPJ(valor) {
    // Remove caracteres não numéricos
    valor = this.normalizeCpfCnpj(valor);

    // CPF
    if (this.isCpf(valor)) {
      let cpf = valor;

      // Verifica se todos os dígitos são iguais
      if (/^(\d)\1+$/.test(cpf)) return false;

      // Calcula o primeiro dígito verificador
      let soma = 0;
      for (let i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i);
      }
      let resto = 11 - (soma % 11);
      let digitoVerificador = resto === 10 || resto === 11 ? 0 : resto;

      // Verifica o primeiro dígito verificador
      if (digitoVerificador !== parseInt(cpf.charAt(9))) return false;

      // Calcula o segundo dígito verificador
      soma = 0;
      for (let i = 0; i < 10; i++) {
        soma += parseInt(cpf.charAt(i)) * (11 - i);
      }
      resto = 11 - (soma % 11);
      digitoVerificador = resto === 10 || resto === 11 ? 0 : resto;

      // Verifica o segundo dígito verificador
      if (digitoVerificador !== parseInt(cpf.charAt(10))) return false;

      return true; // CPF válido
    }

    // CNPJ
    if (this.isCnpj(valor)) {
      if (!/^\d{14}$/.test(valor)) {
        return true;
      }

      let cnpj = valor;

      // Verifica se todos os dígitos são iguais
      if (/^(\d)\1+$/.test(cnpj)) return false;

      // Calcula o primeiro dígito verificador
      let soma = 0;
      let peso = 2;
      for (let i = 11; i >= 0; i--) {
        soma += parseInt(cnpj.charAt(i)) * peso;
        peso = peso === 9 ? 2 : peso + 1;
      }
      let resto = soma % 11;
      let digitoVerificador = resto < 2 ? 0 : 11 - resto;

      // Verifica o primeiro dígito verificador
      if (digitoVerificador !== parseInt(cnpj.charAt(12))) return false;

      // Calcula o segundo dígito verificador
      soma = 0;
      peso = 2;
      for (let i = 12; i >= 0; i--) {
        soma += parseInt(cnpj.charAt(i)) * peso;
        peso = peso === 9 ? 2 : peso + 1;
      }
      resto = soma % 11;
      digitoVerificador = resto < 2 ? 0 : 11 - resto;

      // Verifica o segundo dígito verificador
      if (digitoVerificador !== parseInt(cnpj.charAt(13))) return false;

      return true; // CNPJ válido
    }

    return false; // Tamanho inválido para CPF ou CNPJ
  },
  validarChaveAcesso(chaveAcesso) {
    chaveAcesso = this.normalizeChaveAcesso(chaveAcesso);

    if (chaveAcesso.length !== 44) {
      return false;
    }

    const regex = /^[0-9A-Z]{44}$/;
    if (!regex.test(chaveAcesso)) {
      return false;
    }

    if (!/^\d{44}$/.test(chaveAcesso)) {
      return true;
    }

    const digitos = chaveAcesso.slice(0, 43);
    const digitoVerificador = parseInt(chaveAcesso[43]);

    let soma = 0;
    let peso = 2;

    for (let i = digitos.length - 1; i >= 0; i--) {
      soma += parseInt(digitos[i]) * peso;
      peso = peso === 9 ? 2 : peso + 1;
    }

    const resto = soma % 11;
    const digitoCalculado = resto < 2 ? 0 : 11 - resto;

    return digitoVerificador === digitoCalculado;
  },
  calcularDigitoVerificador(digitos) {
    const pesos = [2, 3, 4, 5, 6, 7, 8, 9];
    let soma = 0;
    for (let i = digitos.length - 1, j = 0; i >= 0; i--, j++) {
      const digito = parseInt(digitos[i]);
      soma += digito * pesos[j % 8];
    }
    const resto = soma % 11;
    let digitoVerificador;
    if (resto === 0 || resto === 1) {
      digitoVerificador = 0;
    } else {
      digitoVerificador = 11 - resto;
    }
    return digitoVerificador;
  },

  async formatarMensagem(mensagem) {
    let resultadoFormatado = [];
    try {
      const linhas = mensagem.split("\n");

      let elementoAtual = null;
      let valorInvalido = null;

      for (let i = 0; i < linhas.length; i++) {
        const linha = linhas[i];

        if (linha.includes("Erro:")) {
          const matchElemento = linha.match(
            /'http:\/\/www\.portalfiscal\.inf\.br\/nfe:(.*?)'/
          );
          const matchValor = linha.match(/The value '([^']+)'/);

          if (matchElemento && matchValor) {
            elementoAtual = matchElemento[1];
            valorInvalido = matchValor[1];

            resultadoFormatado.push({
              erroFormatado: `${elementoAtual} - '${valorInvalido}' é inválido`,
              tagErro: matchElemento[0],
            });
          } else {
            const incompleteMatch = linha.match(
              /The element '(.+?)' in namespace '(.+?)' has (invalid child element|incomplete content) '(.+?)' in namespace '(.+?)'. List of possible elements expected: '(.+?)' in namespace '(.+?)'./
            );

            if (incompleteMatch) {
              const elementoPai = incompleteMatch[1];
              const elementoFilho = incompleteMatch[4];
              const possiveisElementos = incompleteMatch[7];

              resultadoFormatado.push({
                erroFormatado: `O elemento '${elementoPai}' é inválido ou incompleto. Os elementos possíveis são '${possiveisElementos}'`,
                tagErro: incompleteMatch[0],
              });
            }
          }
        }
      }
    } catch (error) {
      resultadoFormatado.push({
        erroFormatado: "",
        tagErro: error,
      });
    }
    return resultadoFormatado;
  },

  async dadosEmailNFe(chave) {
    let dadosEmail = {
      emails: [],
      assuntoEmail: "NF-e " + chave,
      mensagemEmail:
        "<H3>Prezado cliente,</H3><br/>Você está recebendo a Nota Fiscal Eletrônica. Além disso, junto com a mercadoria seguirá o DANFE (Documento Auxiliar da Nota Fiscal Eletrônica), impresso em papel que acompanha o transporte das mesmas.</p><p>Anexo à este e-mail você está recebendo também o arquivo XML da Nota Fiscal Eletrônica. Este arquivo deve ser armazenado eletronicamente por sua empresa pelo prazo de 05 (cinco) anos, conforme previsto na legislação tributária (Art. 173 do Código Tributário Nacional e § 4º da Lei 5.172 de 25/10/1966).</p><br/><p>O DANFE em papel pode ser arquivado para apresentação ao fisco quando solicitado. Todavia, se sua empresa também for emitente de NF-e, o arquivamento eletrônico do XML de seus fornecedores é obrigatório, sendo passível de fiscalização.</p><br/><p>Para se certificar que esta NF-e é válida, queira por favor consultar sua autenticidade no site nacional do projeto NF-e (www.nfe.fazenda.gov.br), utilizando a chave de acesso " +
        chave +
        " .<br/>&nbsp;</p>",
      anexosEmail: [],
    };
    return dadosEmail;
  },

  async dadosEmailCCe(chave) {
    let dadosEmail = {
      emails: [],
      assuntoEmail: "CCe " + chave,
      mensagemEmail:
        "<H3>Prezado cliente,</H3><br/>Você está recebendo a Carta de Correção Eletrônica. Este arquivo deve ser armazenado eletronicamente por sua empresa pelo prazo de 05 (cinco) anos, conforme previsto na legislação tributária (Art. 173 do Código Tributário Nacional e § 4º da Lei 5.172 de 25/10/1966).</p><p>A CC-e em papel pode ser arquivado para apresentação ao fisco quando solicitado. Todavia, se sua empresa também for emitente de CC-e, o arquivamento eletrônico do XML de seus fornecedores é obrigatório, sendo passível de fiscalização.</p><br/><p>Para se certificar que esta CC-e é válida, queira por favor consultar sua autenticidade no site nacional do projeto NF-e (www.nfe.fazenda.gov.br), utilizando a chave de acesso " +
        chave +
        " .<br/>&nbsp;</p>",
      anexosEmail: [],
    };
    return dadosEmail;
  },

  async dadosEmailNFCe(vendasCupom) {
    const user = JSON.parse(localStorage.getItem("user"));
    const serie = String(vendasCupom.serie || "").padStart(3, "0");
    const numeroCupom = String(vendasCupom.cupom || "").padStart(10, "0");
    const nomeEmitente = String(user?.User?.Emitente?.nome || "").toUpperCase();
    const cnpjEmitente = String(user?.User?.Emitente?.cnpj || "");
    const nomeEmpresaWL = this.getNomeEmpresaWL();
    const siteEmpresaWL = this.getSiteWL();
    let body =
      "        <table border='0' width='100%' cellspacing='0' cellpadding='0'>";
    body += "            <tbody>";
    body += "                <tr>";
    body += "                    <td>";
    body +=
      "                        <table style='width: 100%;' border='0' width='100%' cellspacing='0' cellpadding='0'";
    body += "                            bgcolor='#f2f2f2'>";
    body += "                            <tbody>";
    body += "                                <tr>";
    body +=
      "                                    <td style='width: 19.9983%;'><img";
    body +=
      "                                            src='" +
      this.getLogoBlackWL() +
      "' alt='" +
      this.getNomeEmpresaWL() +
      "'";
    body += "                                            height='65' /></td>";
    body +=
      "                                    <td style='width: 74.0017%;'>&nbsp;</td>";
    body += "                                </tr>";
    body += "                            </tbody>";
    body += "                        </table>";
    body += "                    </td>";
    body += "                </tr>";
    body += "                <tr></br>";
    body += "                    <td style='text-align: center;'>";

    if (vendasCupom.modelo === "65") {
      body +=
        "                        <p><strong></br>&nbsp;NFC-e</strong></p>";
    } else {
      body +=
        "                        <p><strong></br>&nbsp;Comprovante de Venda</strong></p>";
    }

    body += "                        <hr />";
    body += "                    </td>";
    body += "                </tr>";
    body += "                <tr>";
    body += "                    <td>";

    if (vendasCupom.modelo === "65") {
      body +=
        "                        <p>Esta mensagem refere-se à NFC-e de série/número <strong>" +
        serie +
        "/" +
        numeroCupom +
        "</strong>,";
    } else {
      body +=
        "                        <p>Esta mensagem refere-se à venda de número <strong>" +
        numeroCupom +
        "</strong>,";
    }

    body +=
      "                            emitida por:<br /> <br />Razão Social: <strong>" +
      nomeEmitente +
      "</strong>";
    body +=
      "                            <br />CNPJ: <strong>" +
      cnpjEmitente +
      "</strong></p>";

    if (vendasCupom.modelo === "65") {
      body +=
        "                        <p>Chave de acesso: <strong>" +
        vendasCupom.chave_nfce +
        "</strong></p>";
    }

    body += "                        <p>&nbsp;</p>";
    body += "                    </td>";
    body += "                </tr>";
    body += "                <tr>";
    body += "                    <td>&nbsp;";
    body += "                        <hr />";

    if (vendasCupom.modelo === "65") {
      body +=
        "                        <p style='text-align: center;'>&nbsp;<strong>OBS.:</strong> Esta mensagem foi enviada automaticamente pelo sistema de NFC-e";
    } else {
      body +=
        "                        <p style='text-align: center;'>&nbsp;<strong>OBS.:</strong> Esta mensagem foi enviada automaticamente pelo sistema de venda";
    }

    body +=
      "                            da <strong>" +
      nomeEmpresaWL +
      "</strong>.<br /><br /></p>";
    body +=
      "                        <p style='text-align: center;'><a href='" +
      siteEmpresaWL +
      "'>" +
      siteEmpresaWL +
      "</a></p></br>";
    body +=
      "                        <table style='background-color: #000000; width: 100%;'>";
    body += "                            <tbody>";
    body += "                                <tr>";
    body +=
      "                                    <td style='width: 131px;'>&nbsp;</td>";
    body += "                                </tr>";
    body += "                            </tbody>";
    body += "                        </table>";
    body += "                    </td>";
    body += "                </tr>";
    body += "            </tbody>";
    body += "        </table>";

    let assunto = "";
    if (vendasCupom.modelo === "65") {
      assunto = "NFC-e " + vendasCupom.chave_nfce;
    } else {
      assunto =
        "Comprovante de Venda nº " +
        vendasCupom.cupom.toString().padStart(10, "0");
    }

    let dadosEmail = {
      emails: [],
      assuntoEmail: assunto,
      mensagemEmail:
        "Este é um email automático, não é necessário respondê-lo." + body,
      anexosEmail: [],
    };
    if (vendasCupom.modelo !== "65") {
      dadosEmail.assuntoEmail = "Comprovante de Venda nº " + numeroCupom;
    }
    dadosEmail.mensagemEmail =
      "Este é um email automático, não é necessário respondê-lo." + body;
    dadosEmail.mensagemWhatsapp =
      vendasCupom.modelo === "65"
        ? `Este é um envio automático da NFC-e.\n\nNFC-e\n\nEsta mensagem refere-se à NFC-e de série/número ${serie}/${numeroCupom}, emitida por:\n\nRazão Social: ${nomeEmitente}\nCNPJ: ${cnpjEmitente}\n\nChave de acesso: ${vendasCupom.chave_nfce}\n\nOBS.: Esta mensagem foi enviada automaticamente pelo sistema de NFC-e da ${nomeEmpresaWL}.\n\n${siteEmpresaWL}`
        : `Este é um envio automático do comprovante de venda.\n\nComprovante de Venda\n\nEsta mensagem refere-se à venda de número ${numeroCupom}, emitida por:\n\nRazão Social: ${nomeEmitente}\nCNPJ: ${cnpjEmitente}\n\nOBS.: Esta mensagem foi enviada automaticamente pelo sistema de venda da ${nomeEmpresaWL}.\n\n${siteEmpresaWL}`;
    return dadosEmail;
  },

  async dadosEmailNFSe(nfse) {
    const user = JSON.parse(localStorage.getItem("user"));
    const serie = String(nfse.serie || "").padStart(5, "0");
    const numero = String(nfse.numero || "").padStart(9, "0");
    const nomeEmitente = String(user?.User?.Emitente?.nome || "").toUpperCase();
    const cnpjEmitente = String(user?.User?.Emitente?.cnpj || "");
    const nomeEmpresaWL = this.getNomeEmpresaWL();
    const siteEmpresaWL = this.getSiteWL();
    let body =
      "        <table border='0' width='100%' cellspacing='0' cellpadding='0'>";
    body += "            <tbody>";
    body += "                <tr>";
    body += "                    <td>";
    body +=
      "                        <table style='width: 100%;' border='0' width='100%' cellspacing='0' cellpadding='0'";
    body += "                            bgcolor='#f2f2f2'>";
    body += "                            <tbody>";
    body += "                                <tr>";
    body +=
      "                                    <td style='width: 19.9983%;'><img";
    body +=
      "                                            src='" +
      this.getLogoBlackWL() +
      "' alt='" +
      this.getNomeEmpresaWL() +
      "'";
    body += "                                            height='65' /></td>";
    body +=
      "                                    <td style='width: 74.0017%;'>&nbsp;</td>";
    body += "                                </tr>";
    body += "                            </tbody>";
    body += "                        </table>";
    body += "                    </td>";
    body += "                </tr>";
    body += "                <tr></br>";
    body += "                    <td style='text-align: center;'>";
    body += "                        <p><strong></br>&nbsp;NFS-e</strong></p>";
    body += "                        <hr />";
    body += "                    </td>";
    body += "                </tr>";
    body += "                <tr>";
    body += "                    <td>";
    body +=
      "                        <p>Esta mensagem refere-se à NFS-e de série/RPS <strong>" +
      serie +
      "/" +
      numero +
      "</strong>,";
    body +=
      "                            emitida por:<br /> <br />Razão Social: <strong>" +
      nomeEmitente +
      "</strong>";
    body +=
      "                            <br />CNPJ: <strong>" +
      cnpjEmitente +
      "</strong></p>";

    const chaveAcesso =
      nfse?.NFSeChave?.codigo_verificacao || nfse?.NFSeChave?.protocolo || "";
    if (chaveAcesso) {
      body +=
        "                        <p>Chave de acesso: <strong>" +
        chaveAcesso +
        "</strong></p>";
    }

    body += "                        <p>&nbsp;</p>";
    body += "                    </td>";
    body += "                </tr>";
    body += "                <tr>";
    body += "                    <td>&nbsp;";
    body += "                        <hr />";
    body +=
      "                        <p style='text-align: center;'>&nbsp;<strong>OBS.:</strong> Esta mensagem foi enviada automaticamente pelo sistema de NFS-e";
    body +=
      "                            da <strong>" +
      nomeEmpresaWL +
      "</strong>.<br /><br /></p>";
    body +=
      "                        <p style='text-align: center;'><a href='" +
      siteEmpresaWL +
      "'>" +
      siteEmpresaWL +
      "</a></p></br>";
    body +=
      "                        <table style='background-color: #000000; width: 100%;'>";
    body += "                            <tbody>";
    body += "                                <tr>";
    body +=
      "                                    <td style='width: 131px;'>&nbsp;</td>";
    body += "                                </tr>";
    body += "                            </tbody>";
    body += "                        </table>";
    body += "                    </td>";
    body += "                </tr>";
    body += "            </tbody>";
    body += "        </table>";

    const numeroNota =
      nfse?.NFSeChave?.numero_nota ||
      String(nfse.numero || "").padStart(9, "0");

    const dadosEmail = {
      emails: [],
      assuntoEmail: "NFS-e " + numeroNota,
      mensagemEmail:
        "Este é um email automático, não é necessário respondê-lo." + body,
      anexosEmail: [],
    };
    dadosEmail.mensagemEmail =
      "Este é um email automático, não é necessário respondê-lo." + body;
    dadosEmail.mensagemWhatsapp =
      `Este é um envio automático da NFS-e.\n\nNFS-e\n\nEsta mensagem refere-se à NFS-e de série/RPS ${serie}/${numero}, emitida por:\n\nRazão Social: ${nomeEmitente}\nCNPJ: ${cnpjEmitente}` +
      (chaveAcesso ? `\n\nChave de acesso: ${chaveAcesso}` : "") +
      `\n\nOBS.: Esta mensagem foi enviada automaticamente pelo sistema de NFS-e da ${nomeEmpresaWL}.\n\n${siteEmpresaWL}`;
    return dadosEmail;
  },

  async enviarEmailComAnexos(store, dadosEmail) {
    if (
      !store ||
      !dadosEmail ||
      !Array.isArray(dadosEmail.emails) ||
      dadosEmail.emails.length <= 0
    ) {
      return {
        Success: false,
        Message: "Nenhum e-mail informado para envio.",
      };
    }

    const email = {
      emails: dadosEmail.emails,
      celular: "",
      titulo: dadosEmail.assuntoEmail || "",
      mensagem: dadosEmail.mensagemEmail || "",
      anexos: dadosEmail.anexosEmail || [],
    };

    return await store.dispatch("compartilhamento/enviarEmail", email);
  },

  escapeRegExp(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  },

  async consultarCNPJ(cnpj) {
    const cnpjLimpo = this.normalizeCpfCnpj(cnpj);

    if (!/^\d{14}$/.test(cnpjLimpo)) {
      throw new Error("Consulta disponivel apenas para CNPJ numérico.");
    }

    const response = await axios.get(
      `https://publica.cnpj.ws/cnpj/${cnpjLimpo}`
    );
    return response;
  },

  async consultarIpExterno() {
    //const response = await axios.get(`https://api.ipify.org/?format=json`);
    const response = await axios.get(`https://ifconfig.me/ip`);
    return response.data.ip;
  },
  retornarNavegador() {
    return platform.name;
  },
  async retornarSistemaOperacional() {
    var sistema = platform.os.family || "Outro";
    var versao = platform.os.version || "";

    try {
      if (sistema === "Windows" && versao === "10") {
        const ua = await navigator.userAgentData.getHighEntropyValues([
          "platformVersion",
        ]);
        if (navigator.userAgentData.platform === "Windows") {
          const majorPlatformVersion = parseInt(
            ua.platformVersion.split(".")[0]
          );
          if (majorPlatformVersion >= 13) {
            return "Windows 11";
          }
        }
      }
    } catch (error) {
      return `${sistema} ${versao}`;
    }

    return `${sistema} ${versao}`;
  },
  retornarTipoDispositivo() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const iPadOS13Up =
      window.navigator.platform === "MacIntel" &&
      window.navigator.maxTouchPoints > 1;

    if (userAgent.includes("windows")) {
      return "Windows";
    } else if (userAgent.includes("ipod")) {
      return "Ipod";
    } else if (userAgent.includes("ipad") || iPadOS13Up) {
      return "Ipad";
    } else if (userAgent.includes("dingtalk")) {
      return "Dingding";
    } else if (userAgent.includes("micromessenger")) {
      return "Wechat";
    } else if (userAgent.includes("miniprogram")) {
      return "WechatMiniApp";
    } else if (userAgent.includes("iphone")) {
      return "Iphone";
    } else if (userAgent.includes("android")) {
      return "Android";
    } else {
      return "Outro";
    }
  },
  requestFocus(id) {
    var element = document.getElementById(id);
    if (element) {
      element.focus();
    }
  },
  requestFocusSelect(id) {
    var element = document.getElementById(id);
    if (element) {
      element.focus();
      element.select();
    }
  },

  async urlToBase64(pdfUrl) {
    try {
      const response = await fetch(pdfUrl);
      const blob = await response.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => resolve(reader.result.split(",")[1]);
        reader.onerror = reject;
      });
    } catch (error) {
      console.log(error);
      return null;
    }
  },

  imprimirHtml(idComponente) {
    const elemento = document.getElementById(idComponente);
    if (!elemento) return;

    const conteudo = elemento.innerHTML;
    const janela = window.open("", "_blank", "width=1100,height=1000");
    const estilo = `
      <style>
        * {
          font-family: Arial, sans-serif;
          font-size: 10pt;
        }
        h1, h2, h3, h4, h5 {
          margin: 0;
        }
        button {
          display: none;
        }
        table {
          width: 1050px;
          margin: 0 auto;
          border-collapse: collapse;
        }
        table, th, td {
          border: 1px solid #ccc;
        }
        th, td {
          padding: 4px;
          text-align: left;
        }
        .card, .shadow-sm {
          border: 0px solid #ddd;
          box-shadow: none !important;
          padding: 8px;
          margin-bottom: 8px;
        }
        .row {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }
        .col, .col-xxl-6 {
          flex: 1;
          min-width: 45%;
        }
  
        @media print {
          .row:has(.apexcharts-canvas) {
            flex-direction: column !important;
          }

          .row:has(.apexcharts-canvas) .col-xxl-6 {
            width: 100% !important;
            max-width: 100% !important;
          }

          .row:has(.apexcharts-canvas) .mb-4,
          .row:has(.apexcharts-canvas) .mb-md-5,
          .row:has(.apexcharts-canvas) .mb-xl-4 {
            margin-bottom: 1rem !important;
          }

          .row:has(.apexcharts-canvas) .card {
            page-break-inside: avoid;
          }

          .apexcharts-legend {
            display: flex !important;
            flex-wrap: wrap !important;
            justify-content: center !important;
            margin-top: 8px !important;
            position: static !important;
          }

          .apexcharts-legend-series {
            margin: 4px 8px !important;
            font-size: 10pt !important;
          }
        }
      </style>
    `;

    janela.document.write(`
      <html>
        <head>
          <title>${this.generateUuidv4()}</title>
          ${estilo}
        </head>
        <body onload="window.print(); window.close();">
          ${conteudo}
        </body>
      </html>
    `);
    janela.document.close();
  },

  retornarPlanos() {
    const user = JSON.parse(localStorage.getItem("user"));
    const cnpj = user.User.Emitente.Revenda.cnpj;

    const tipoRevenda =
      Object.keys(config.revendas).find(
        (key) => config.revendas[key].cnpj === cnpj
      ) || "revenda";

    const planos = config.revendas[tipoRevenda].planos;
    return planos;
  },

  retornarPlano(tipoPacote) {
    const planos = this.retornarPlanos();
    const tipoPacoteNormalizado = Number(tipoPacote);
    const plano = planos.find((p) => Number(p.id) === tipoPacoteNormalizado);
    return plano || null;
  },

  isMobile() {
    return (
      Capacitor.isNativePlatform() ||
      /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
  },

  parseCurrencyValue(value) {
    if (value === null || value === undefined || value === "") return 0;
    if (typeof value === "number") return value;

    if (typeof value === "string") {
      let normalized = value.trim();

      // remove tudo que não for número, vírgula, ponto ou sinal
      normalized = normalized.replace(/[^\d.,-]/g, "");

      if (!normalized) return 0;

      const hasComma = normalized.includes(",");
      const hasDot = normalized.includes(".");

      if (hasComma && hasDot) {
        // Ex: 1.250,75 ou 1,250.75
        if (normalized.lastIndexOf(",") > normalized.lastIndexOf(".")) {
          // vírgula é decimal
          normalized = normalized.replace(/\./g, "").replace(",", ".");
        } else {
          // ponto é decimal
          normalized = normalized.replace(/,/g, "");
        }
      } else if (hasComma) {
        const parts = normalized.split(",");

        if (parts.length === 2) {
          const decimalPart = parts[1];

          if (decimalPart.length === 2) {
            // Ex: 18,70 -> decimal
            normalized = normalized.replace(",", ".");
          } else if (decimalPart.length === 3) {
            // Ex: 1,029 -> milhar
            normalized = normalized.replace(/,/g, "");
          } else {
            // fallback
            normalized = normalized.replace(",", ".");
          }
        } else {
          // múltiplas vírgulas -> remove como milhar
          normalized = normalized.replace(/,/g, "");
        }
      } else if (hasDot) {
        const parts = normalized.split(".");

        if (parts.length === 2) {
          const decimalPart = parts[1];

          if (decimalPart.length === 2) {
            // Ex: 18.70 -> decimal
            // mantém
          } else if (decimalPart.length === 3) {
            // Ex: 1.029 -> milhar
            normalized = normalized.replace(/\./g, "");
          }
        } else {
          // múltiplos pontos -> remove como milhar
          normalized = normalized.replace(/\./g, "");
        }
      }

      const parsed = Number(normalized);
      return isNaN(parsed) ? 0 : parsed;
    }

    return 0;
  },

  parseIntegerValue(value) {
    if (value === null || value === undefined || value === "") return 0;
    if (typeof value === "number") return Math.trunc(value);

    if (typeof value === "string") {
      let normalized = value.trim();

      normalized = normalized.replace(/[^\d.,-]/g, "");

      const hasComma = normalized.includes(",");
      const hasDot = normalized.includes(".");

      if (hasComma && hasDot) {
        if (normalized.lastIndexOf(",") > normalized.lastIndexOf(".")) {
          normalized = normalized.replace(/\./g, "").replace(",", ".");
        } else {
          normalized = normalized.replace(/,/g, "");
        }
      } else if (hasComma) {
        normalized = normalized.replace(",", ".");
      }

      const parsed = Number(normalized);
      return isNaN(parsed) ? 0 : Math.trunc(parsed);
    }

    return 0;
  },
};

export default func;
